module.exports = __webpack_public_path__ + "static/media/footerLogo.792a8221.svg";